"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var validation_error_1 = require("./validation_error");
exports.Type = {
    unknown: {
        definition: {
            type: "unknown"
        },
        eval: function (value) {
            return value;
        }
    },
    null: {
        definition: {
            type: "null"
        },
        eval: function (value) {
            if (value !== null) {
                throw new validation_error_1.ValidationError("Not null.");
            }
            return null;
        }
    },
    string: {
        definition: {
            type: "string"
        },
        eval: function (value) {
            if (typeof value !== "string") {
                throw new validation_error_1.ValidationError("Not a string.");
            }
            return value;
        }
    },
    number: {
        definition: {
            type: "number"
        },
        eval: function (value) {
            if (typeof value !== "number") {
                throw new validation_error_1.ValidationError("Not a number.");
            }
            return value;
        }
    },
    boolean: {
        definition: {
            type: "boolean"
        },
        eval: function (value) {
            if (typeof value !== "boolean") {
                throw new validation_error_1.ValidationError("Not a boolean.");
            }
            return value;
        }
    },
    literal: function (def) {
        return {
            definition: {
                type: "literal",
                settings: { values: Object.keys(def) }
            },
            eval: function (value) {
                if (typeof value !== "string" || !def.hasOwnProperty(value)) {
                    throw new validation_error_1.ValidationError("Incorrect literal.");
                }
                return value;
            }
        };
    },
    array: function (spec) {
        return {
            definition: {
                type: "array",
                nested: { element: spec.definition }
            },
            eval: function (data, options) {
                var settings = __assign({ failEarly: false, skipInvalid: false }, options.global, options.local);
                if (!(data instanceof Array)) {
                    throw new validation_error_1.ValidationError("Not an array.");
                }
                var values = [];
                var nestedErrors = [];
                for (var i = 0; i < data.length && (!settings.failEarly || !nestedErrors.length); ++i) {
                    try {
                        values.push(spec.eval(data[i], { global: options.global }));
                    }
                    catch (err) {
                        if (err instanceof validation_error_1.ValidationError) {
                            if (!settings.skipInvalid) {
                                nestedErrors.push(new validation_error_1.ValidationError("Evaluation of array element at index \"" + i + "\" failed.", { key: i, nestedErrors: [err] }));
                            }
                        }
                        else {
                            throw err;
                        }
                    }
                }
                if (nestedErrors.length) {
                    throw new validation_error_1.ValidationError("Array validation failed.", { nestedErrors: nestedErrors });
                }
                return values;
            }
        };
    },
    object: function (schema) {
        return {
            definition: {
                type: "object",
                nested: Object.keys(schema).reduce(function (o, a) {
                    o[a] = schema[a].definition;
                    return o;
                }, {})
            },
            eval: function (data, options) {
                var settings = __assign({ strict: true, failEarly: false }, options.global, options.local);
                if (typeof data !== "object" || data === null || data instanceof Array) {
                    throw new validation_error_1.ValidationError("Not a regular object.");
                }
                if (settings.strict) {
                    var extraKeys = Object.keys(data).filter(function (k) { return !(k in schema); });
                    if (extraKeys.length) {
                        throw new validation_error_1.ValidationError("Data has attributes that are not part of the schema: \"" + extraKeys.join(",") + "\".");
                    }
                }
                var nestedErrors = [];
                var attributes = Object.keys(schema);
                var model = {};
                for (var attrIndex = 0; attrIndex < attributes.length && (!settings.failEarly || !nestedErrors.length); ++attrIndex) {
                    var attr = attributes[attrIndex];
                    var attrSpec = schema[attr];
                    if (!(attr in data) && !attrSpec.optional) {
                        nestedErrors.push(new validation_error_1.ValidationError("Attribute not present: \"" + attr + "\".", { key: attr }));
                    }
                    else {
                        if (!attrSpec.optional || data.hasOwnProperty(attr)) {
                            var value = data[attr];
                            try {
                                model[attr] = attrSpec.eval(value, { global: options.global });
                            }
                            catch (err) {
                                if (err instanceof validation_error_1.ValidationError) {
                                    nestedErrors.push(new validation_error_1.ValidationError("Evaluation of attribute \"" + attr + "\" failed.", { key: attr, nestedErrors: [err] }));
                                }
                                else {
                                    throw err;
                                }
                            }
                        }
                    }
                }
                if (nestedErrors.length) {
                    throw new validation_error_1.ValidationError("Object validation failed.", { nestedErrors: nestedErrors });
                }
                return model;
            }
        };
    },
    map: function (keySpec, valueSpec) {
        return {
            definition: {
                type: "map",
                nested: {
                    key: keySpec.definition,
                    value: valueSpec.definition
                }
            },
            eval: function (data, options) {
                var settings = __assign({ failEarly: false, skipInvalidKeys: false, skipInvalidValues: false }, options.global, options.local);
                if (typeof data !== "object" || data === null || data instanceof Array) {
                    throw new validation_error_1.ValidationError("Not a regular object.");
                }
                var result = {};
                var nestedErrors = [];
                var dataKeys = Object.keys(data);
                for (var dataKeyIndex = 0; dataKeyIndex < dataKeys.length && (!settings.failEarly || !nestedErrors.length); ++dataKeyIndex) {
                    var dk = dataKeys[dataKeyIndex];
                    try {
                        var rk = keySpec.eval(dk, { global: options.global });
                        try {
                            result[rk] = valueSpec.eval(data[dk], { global: options.global });
                        }
                        catch (err) {
                            if (err instanceof validation_error_1.ValidationError) {
                                if (!settings.skipInvalidValues) {
                                    nestedErrors.push(new validation_error_1.ValidationError("Evaluation of map value for key \"" + dk + "\" failed.", { key: dk, nestedErrors: [err] }));
                                }
                            }
                            else {
                                throw err;
                            }
                        }
                    }
                    catch (err) {
                        if (err instanceof validation_error_1.ValidationError) {
                            if (!settings.skipInvalidKeys) {
                                nestedErrors.push(new validation_error_1.ValidationError("Evaluation of map key \"" + dk + "\" failed.", { key: dk, nestedErrors: [err] }));
                            }
                        }
                        else {
                            throw err;
                        }
                    }
                }
                if (nestedErrors.length) {
                    throw new validation_error_1.ValidationError("Map validation failed.", { nestedErrors: nestedErrors });
                }
                return result;
            }
        };
    },
    instance: function (ctor) {
        return {
            definition: {
                type: "instance",
                settings: { className: "name" in ctor ? ctor.name : "" }
            },
            eval: function (value) {
                if (!(value instanceof ctor)) {
                    throw new validation_error_1.ValidationError("Not an instance of \"" + ctor.name + "\".");
                }
                return value;
            }
        };
    },
    dateString: {
        definition: {
            type: "dateString"
        },
        eval: function (value) {
            var ts = Date.parse("" + value);
            if (ts % 1 !== 0) {
                throw new validation_error_1.ValidationError("Not a valid date.");
            }
            return new Date(ts);
        }
    },
    numeric: {
        definition: {
            type: "numeric"
        },
        eval: function (value) {
            var num = Number(value) + 0;
            if (!Number.isFinite(num)) {
                throw new validation_error_1.ValidationError("Not a finite number.");
            }
            return num;
        }
    }
};
//# sourceMappingURL=type.js.map